<template>
  <v-dialog :value="dialogProp.show" persistent max-width="700">
    <v-card class="elevation-12">
      <v-toolbar dense :dark="$vuetify.theme.dark" color="primary">
        <v-toolbar-title>
          {{ $t('Добавление позиции') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-row v-if="!!generalError || isLoading" class="my-0 py-0 mx-1">
        <v-col cols="12">
          <v-progress-linear :active="isLoading" color="loader" indeterminate />
        </v-col>
        <v-col class="mx-1">
          <general-error v-if="!!generalError" />
        </v-col>
      </v-row>
      <v-card-text class="pt-3">
        <position-info-fix
            v-if="dialogProp.lot.lotType === LOT_TYPES.REQUEST_OFFERS && dialogProp.lot.premiumType === PREMIUM_TYPES.FIX"
            ref="position"
            :lot-description="lotDescription"
            :lot-owner-organization-name="lotOwnerOrganizationName"
            :validated="createPosition" />
        <position-divisible-volume-info-fix
            v-if="dialogProp.lot.lotType === LOT_TYPES.REQUEST_OFFERS_DIVISIBLE_VOLUME && dialogProp.lot.premiumType === PREMIUM_TYPES.FIX"
            ref="position"
            :lot-description="lotDescription"
            :lot-owner-organization-name="lotOwnerOrganizationName"
            :validated="createPosition" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
            id="cancelConfirmBtn"
            class="ma-1"
            color="primary"
            @click="cancel">
          {{ $t('Отмена') }}
        </v-btn>
        <v-btn
            id="continueOperationBtn"
            class="ma-1"
            :disabled="isLoading"
            color="primary"
            @click.stop="continueOperation">
          {{ $t('Продолжить') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import PositionInfoFix from './PositionInfoFix.vue'
  import PositionDivisibleVolumeInfoFix from './PositionDivisibleVolumeInfoFix.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import { mapActions } from 'vuex'
  import { LOT_TYPES, PREMIUM_TYPES } from '@/constants/business'
  import { LOT_POSITIONS_MANAGEMENT } from '@/constants/store.js'

  export default {
    components: {
      GeneralError,
      PositionInfoFix,
      PositionDivisibleVolumeInfoFix
    },
    props: {
      dialogProp: {
        type: Object,
        default: () => {
          return {
            lot: {
              lotId: null,
              premiumType: null
            },
            show: false,
            callback: null
          }
        }
      }
    },
    data () {
      return {
        LOT_TYPES,
        PREMIUM_TYPES,
        isLoading: false
      }
    },
    computed: {
      lotDescription () {
        return this.dialogProp.lot?.lotDescription
      },
      lotOwnerOrganizationName () {
        return this.dialogProp.lot?.clientOrganizationFullName || this.dialogProp.lot?.organizer?.organizationName
      }
    },
    created () {
      if (!this.dialogProp.lot.premiumType || !this.dialogProp.lot.lotId) {
        this.showErrorAction({
          message: this.$t('Торговая процедура не определена.')
        })
      }
    },
    methods: {
      ...mapActions(LOT_POSITIONS_MANAGEMENT.NAMESPACE, {
        createPositionAction: LOT_POSITIONS_MANAGEMENT.ACTIONS.CREATE_POSITION
      }),
      continueOperation: async function () {
        try {
          this.isLoading = true
          await this.$refs.position.validate()
          if (this.dialogProp.callback) {
            await this.dialogProp.callback()
            this.isLoading = false
            this.cancel()
          }
        } catch (error) {
          this.isLoading = false
          this.throwIfUnknownError(error)
        }
      },
      createPosition: async function (position) {
        const model = {
          premiumType: this.dialogProp.lot.premiumType,
          lotId: this.dialogProp.lot.lotId,
          lotType: this.dialogProp.lot.lotType,
          position
        }
        await Promise.all([
          this.createPositionAction(model)
        ])
      },
      cancel: function () {
        this.$emit('close')
      }
    }
  }
</script>
